import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [NgSelectModule, FormsModule, CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  step = 1;
  public installations: string[] = [
    "Naval Base San Diego",
    "Naval Base Coronado",
    "Naval Base Point Loma",
    "Marine Corps Air Station Miramar",
    "Marine Corps Recruit Depot San Diego",
    "Marine Corps Base Camp Pendleton",
    "U.S. Coast Guard Sector and Air Station San Diego"
  ]
  selected: any;
  address = '';
  firstName = '';
  lastName = '';
  email = '';
  phone = '';

  goToStep2() {
    if (!this.selected) return;
    this.step = 2;
  }

  submitLead() {
    if (!this.firstName || !this.lastName || !this.email || !this.phone) {
      alert('There are missing fields, please check over and re submit.');
      return;
    }

    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    const phoneValid = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(this.phone);

    if (!emailValid || !phoneValid) {
      console.log("invalid")
      alert('Please fix validation errors.');
      return;
    }

    const lead = {
      address: this.selected,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone
    };



    fetch('https://square-dew-d766.michaellostrittojr.workers.dev/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lead)
    })
      .then(res => res.json())
      .then(() => {
        alert('Thank you. A PCS specialist will contact you within 48 hours.');
        this.step = 1;
      })
      .catch(() => alert('Submission failed.'));
  }
}
